import { RecurrencyAttributes, ApiResponse } from "../types";
import { apiClient } from "./apiClient";

export const recurrenciesApi = {
  // Get all recurrencies
  async getRecurrencies(): Promise<ApiResponse<RecurrencyAttributes[]>> {
    try {
      const data = await apiClient.get<{ data: RecurrencyAttributes[] } | RecurrencyAttributes[]>(
        "/recurrencies"
      );

      // Handle both response formats (with or without data wrapper)
      const recurrencies = Array.isArray(data) ? data : (data as any).data || data;

      return {
        success: true,
        data: recurrencies,
      };
    } catch (error: any) {
      return {
        success: false,
        error: error.message || "Unknown error occurred",
      };
    }
  },

  // Get recurrency by ID
  async getRecurrency(id: number): Promise<ApiResponse<RecurrencyAttributes>> {
    try {
      const data = await apiClient.get<any>(`/recurrencies/${id}`);

      return {
        success: true,
        data: data.data || data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Create a new recurrency
  async createRecurrency(
    recurrencyData: Omit<RecurrencyAttributes, "id" | "createdAt" | "updatedAt">
  ): Promise<ApiResponse<RecurrencyAttributes>> {
    try {
      const data = await apiClient.post<any>("/recurrencies", recurrencyData);

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Update an existing recurrency
  async updateRecurrency(
  id: number,
    recurrencyData: Partial<Omit<RecurrencyAttributes, "id" | "createdAt" | "updatedAt">>
  ): Promise<ApiResponse<RecurrencyAttributes>> {
    try {
      const data = await apiClient.put<any>(`/recurrencies/${id}`, recurrencyData);

      return {
        success: true,
        data: data.data,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  // Delete a recurrency
  async deleteRecurrency(id: number): Promise<ApiResponse<boolean>> {
    try {
  await apiClient.delete(`/recurrencies/${id}`);

      return {
        success: true,
        data: true,
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};
